import React, {useState, useEffect, useRef} from "react"
import handleChange from "../Scripts/handleChangeCreate"

function CreateResource(props) {

    const titleRef = useRef()
    const titleCountRef = useRef()
    const [title, setTitle] = useState({value: '', max: 128})
    const URLRef = useRef()
    const URLCountRef = useRef()
    const [URL, setURL] = useState({value: '', max: 8000})

    useEffect(() => {
        props.setResources((prev) => {
            const updated = [...prev]
            updated[props.index] = {key: props.resourceKey, resource: title.value, url: URL.value}
            return updated
        })
    }, [title, URL])

    return (
        <div className="createresource">
        <button className="removeresource" onClick={(index) => {props.removeResource(props.index)}}>-</button>
            <input ref={titleRef} className="createinput createresourcetitle" placeholder="resource title..." onChange={(e) => {handleChange(e.target.value, "resource", titleRef, titleCountRef, title, setTitle)}}></input>
            <p ref={titleCountRef} className="charcount">{title.value.length}/{title.max}</p>
            <input ref={URLRef} className="createinput createresourceurl" placeholder="url..." onChange={(e) => {handleChange(e.target.value, "resource", URLRef, URLCountRef, URL, setURL)}}></input>
            <p ref={URLCountRef} className="charcount">{URL.value.length}/{URL.max}</p>
        </div>
    )
}

export default CreateResource
